
import { experienceData } from '../../../mocks/experience';

export default function Experience() {
  return (
    <section id="experience" className="py-32 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-light mb-6 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            The Experience
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Beyond the runway. A complete immersion in Caribbean creativity.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {experienceData.map((item, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="relative overflow-hidden aspect-[16/10] mb-6">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <h3 className="text-3xl font-light text-white mb-2 tracking-wide" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {item.title}
                  </h3>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
